

let n = 0



export class Key {
  id: string

  constructor() {
    this.id = `${n++}`
  }
}
